import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import DesignerListItem from 'apps/find-designers/components/Listing/DesignerListItem';
import BlankSlate from 'components/BlankSlate';
import initTypeform from 'utils/initTypeform';
import { Designers } from 'apps/find-designers/propTypes';
import { getComponentClasses } from '@99designs/common/utils/app';
import { InviteContextProvider } from './InviteContext';

class DesignerList extends Component {
    componentDidUpdate() {
        if (this.props.designers.length) return null;
        return initTypeform();
    }

    blankSlateMessage() {
        return (
            <span>
                <FormattedMessage id="blank_slate_message" />
            </span>
        );
    }

    blankSlate() {
        if (this.props.designers.length) return null;

        return (
            <BlankSlate
                title={<FormattedMessage id="no_designers_found" />}
                message={this.blankSlateMessage()}
                variations={['wide', 'padded-top']}
            />
        );
    }

    render() {
        const classes = getComponentClasses('designer-list', [
            classNames({ 'loading-overlay': this.props.isLoading }),
        ]);

        return (
            <div>
                <div className={classes}>
                    <InviteContextProvider>
                        {this.blankSlate()}
                        {this.props.designers.map(designer => (
                            <DesignerListItem
                                key={designer.id}
                                designer={designer}
                                designs={designer.designs}
                                urls={designer.urls}
                                expertiseCategories={designer.expertiseCategories}
                            />
                        ))}
                    </InviteContextProvider>
                </div>
            </div>
        );
    }
}

DesignerList.defaultProps = {
    designers: [],
    isLoading: false,
    currentUser: {
        isIdentified: false,
    },
};

DesignerList.propTypes = {
    designers: Designers.isRequired,
    isLoading: PropTypes.bool,
    currentUser: PropTypes.shape({
        isIdentified: PropTypes.bool,
    }),
};

export default DesignerList;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/DesignerList.jsx